var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.084 20a1 1 0 0 1 0 2h-16a1 1 0 0 1 0-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.204 2.837a2.86 2.86 0 0 1 4.043 4.043l-9.034 9.033c-.942.941-1.54 1.553-2.286 1.97-.416.232-1.026.425-1.616.59-.617.171-1.326.34-1.996.5a1 1 0 0 1-1.204-1.205c.16-.669.328-1.378.5-1.996.164-.59.358-1.2.59-1.615.417-.746 1.029-1.345 1.97-2.286zm-7.62 10.448c-1.017 1.018-1.386 1.4-1.637 1.848-.101.18-.242.574-.409 1.175q-.042.157-.084.32.166-.04.321-.082c.602-.168.995-.308 1.176-.41.448-.25.83-.62 1.848-1.637l7.012-7.013-1.214-1.214zM17.834 4.25a.86.86 0 0 0-1.215 0l-.607.606 1.215 1.215.607-.606a.86.86 0 0 0 0-1.215",
    clipRule: "evenodd"
  })));
};
export default Svg24;